<template>
  <div class="k_b1" style="margin: 20px; width: calc(100% - 40px); height: 100%;">
    <i class="k_top_left"></i>
    <i class="k_top_right"></i>
    <i class="k_bottom_left"></i>
    <i class="k_bottom_rigth"></i>
    <div style="height: 87%;padding: 10px 10px 0 10px;">
      <div class="memberPie" ref="echarts"></div>
    </div>
  </div>
</template>

<script>
import { EchatsMixin } from '@/utils/echarts';
export default {
  mixins: [EchatsMixin],
  name: 'echartsLine',
  data() {
    return {};
  },
  props: {
    toilet: { default: [] },
    // 默认折线图
    serviceType: { default: "line" },
  },
  computed: {},
  watch: {
    toilet: {
      handler(n) {
        if (n) {
          this.echarts_satisfied(n);
        }
      },
      deep: true
    }
  },
  methods: {
    // 满意度echarts
    echarts_satisfied(data) {
      let myChart = this.resizeEcharts();
      let option = {
        color: ["#1FD6E8"],
        grid: {
          top: 30,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        xAxis: [
          {
            type: "category",
            data: data.day,
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            splitNumber: 2,
            type: "value",
            name: data.com,
            nameTextStyle: {
              color: "#fff",
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#fff",
              },
            },
          },
        ],
        series: [
          {
            name: "数据",
            type: this.serviceType,
            barWidth: "60%",
            data: data.list,
          },
        ],
      };
      this.autoMatic(myChart, option.series[0].data.length);
      myChart.clear();
      myChart.setOption(option, true);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.memberPie {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/html/echartsLine.vue